module.exports = __webpack_public_path__ + "static/phisymap-f8ffa9ae8b8c0212305f3272c45cd1f6.png";